import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { CaptchaProtectedRender } from '@dealstack/frontend/shared/components/CaptchaProtectedRender/CaptchaProtectedRender';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { Button, Center, Flex, Text } from '@mantine/core';
import { memo } from 'react';

interface Props {
	onSubmit: () => void;
	onClose: () => void;
}
const DeleteFormTemplateConfirmationModal = ({ onSubmit, onClose }: Props) => {
	return (
		<Modal
			onClose={onClose}
			reactModalProps={{ style: { content: { width: '38rem', textAlign: 'center' } } }}
		>
			<Flex direction="column" gap="1rem">
				<div>
					<AssetsLoader src="/context/admin/mip-manage/attention.png" />
				</div>

				<Text size="B3Bold">Are you sure you want to delete this form template?</Text>

				<Text size="B5Bold" c="red.6" mb="2rem">
					Any open completion workflows for this form will be revoked, and the form will
					no longer appear in the app UI!
				</Text>

				<CaptchaProtectedRender>
					<Center mt="2rem">
						<Button
							onClick={onSubmit}
							rightSection={<Icon variant="checkmark-circle-contained-filled" />}
							variant="primary"
							fullWidth
						>
							Confirm
						</Button>
					</Center>
				</CaptchaProtectedRender>
			</Flex>
		</Modal>
	);
};
const _DeleteFormTemplateConfirmationModalExport = memo(DeleteFormTemplateConfirmationModal);

export { _DeleteFormTemplateConfirmationModalExport as DeleteFormTemplateConfirmationModal };
